import Form from '@admin/components/form'
import * as options from '../variables'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Button extends React.Component {

  static propTypes = {
    config: PropTypes.object,
    onDone: PropTypes.func,
    onUpdate: PropTypes.func
  }

  state = {
    config: null
  }

  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefault(),
        ...this.props.config
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this.props.onUpdate(config)
    }
  }

  _getForm() {
    const { config } = this.state
    return {
      title: 't(Button Block)',
      onChange: this._handleChange,
      onCancel: this._handleDone,
      cancelSvg: 'chevron_left',
      saveText: null,
      buttons: [
        { label: 't(Done)', color: 'blue', handler: this._handleDone }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Button Text)', name: 'content', type: 'textfield', defaultValue: config.content },
                { label: 't(Link To)', name: 'link_strategy', type: 'dropdown', options: options.link_strategies, defaultValue: config.link_strategy },
                ...this._getLinkStrategy()
              ]
            }
          ]
        }, {
          label: 't(Style)',
          sections: [
            {
              fields: [
                { label: 't(Background)', name: 'background_color', type: 'colorfield', defaultValue: config.background_color },
                this._getBorder('border', 'Border'),
                { label: 't(Padding)', name: 'padding', type: 'dropdown', options: options.paddings, defaultValue: config.padding }
              ]
            },
            {
              label: 't(Button Style)',
              fields: [
                { label: 't(Background)', name: 'button_background_color', type: 'colorfield', defaultValue: config.button_background_color },
                { label: 't(Padding)', name: 'button_padding', type: 'dropdown', options: options.paddings, defaultValue: config.button_padding },
                { label: 't(Rounded Corners)', name: 'button_border_radius', type: 'range', min: 0, max: 20, defaultValue: config.button_border_radius }
              ]
            },
            {
              label: 't(Button Text Style)',
              fields: [
                { label: 't(Font Family)', name: 'font_family', type: 'fontfamilyfield', defaultValue: config.font_family },
                { type: 'fields', fields: [
                  { label: 't(Font Size)', name: 'font_size', type: 'dropdown', options: options.font_sizes, defaultValue: config.font_size },
                  { label: 't(Color)', name: 'color', type: 'colorfield', defaultValue: config.color }
                ] },
                { type: 'fields', fields: [
                  { label: 't(Format)', name: 'format', type: 'formatfield', defaultValue: config.format },
                  { label: 't(Alignment)', name: 'text_align', type: 'alignmentfield', defaultValue: config.text_align }
                ] },
                { type: 'fields', fields: [
                  { label: 't(Line Height)', name: 'line_height', type: 'dropdown', options: options.line_heights, defaultValue: config.line_height },
                  { label: 't(Letter Spacing)', name: 'letter_spacing', type: 'dropdown', options: options.letter_spacing, defaultValue: config.letter_spacing }
                ] }
              ]
            }
          ]
        }, {
          label: 't(Settings)',
          sections: [
            {
              fields: [
                { label: 't(Width)', name: 'display', type: 'dropdown', options: options.displays, defaultValue: config.display },
                ...this._getAlignment()
              ]
            }
          ]
        }
      ]
    }
  }

  _getDefault() {
    return {
      content: 'Click Me',
      link_strategy: 'web',
      url: null,
      email_address: null,
      email_subject: null,
      email_body: null,
      asset_id: null,
      background_color: null,
      padding: 16,
      border: null,
      button_background_color: '#2185D0',
      button_padding: 8,
      button_border_radius: null,
      font_family: null,
      font_size: null,
      color: '#FFFFFF',
      format: ['bold'],
      text_align: 'center',
      line_height: null,
      letter_spacing: null,
      display: 'block',
      align: 'center'
    }
  }

  _getAlignment() {
    const { config } = this.state
    if(config.display === 'block') return []
    return [
      { label: 't(Align)', name: 'align', type: 'dropdown', options: options.alignments, defaultValue: config.align }
    ]
  }

  _getBorder(type, label) {
    const { config } = this.state
    if(!config[`${type}_style`]) {
      return { label, name: `${type}_style`, type: 'dropdown', options: options.border_styles, placeholder: 'Style', defaultValue: config[`${type}_style`] }
    }
    return { label, type:'fields', fields: [
      { name: `${type}_style`, type: 'dropdown', options: options.border_styles, placeholder: 'Style', defaultValue: config[`${type}_style`] },
      { name: `${type}_width`, type: 'dropdown', options: options.border_widths, placeholder: 'Width', defaultValue: config[`${type}_width`] },
      { name: `${type}_color`, type: 'colorfield', defaultValue: config[`${type}_color`] }
    ] }
  }

  _getLinkStrategy() {
    const { config } = this.state
    if(config.link_strategy === 'web') {
      return [
        { label: 'Web Address', name: 'url', type: 'textfield', defaultValue: config.url  }
      ]
    } else if(config.link_strategy === 'email') {
      return [
        { label: 't(Email Address)', name: 'email_address', type: 'textfield', defaultValue: config.email_address },
        { label: 't(Message Subject)', name: 'email_subject', type: 'textfield', defaultValue: config.email_subject },
        { label: 't(Message Body)', name: 'email_body', type: 'textfield', defaultValue: config.email_body }
      ]
    } else if(config.link_strategy === 'form') {
      return [
        { label: 't(Form)', name: 'form_id', type: 'lookup', endpoint: '/api/admin/forms/forms', valueKey: 'id', textKey: 'title', defaultValue: config.form_id }
      ]
    } else if(config.link_strategy === 'asset') {
      return [
        { label: 'File', name: 'asset_id', type: 'attachmentfield', prompt: 't(Choose File)', defaultValue: config.asset_id}
      ]
    }
    return []
  }

  _handleChange(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

  _handleDone() {
    this.props.onDone()
  }

}

export default Button
